/**
 * Created by Greg Forel on 27/09/2016.
 * Calculate the Layout Level of a node
 * Layout Level starts at 0 (top nodes) and increase by 1
 */
import { WbsLayout } from './WbsLayout';

export class WbsLayoutLevel {
  private static levelFound: number;

  public static getLayoutLevel(cy: Cy.Core, node: Cy.NodeCollection): number {
    let level: number = -1;
    WbsLayoutLevel.levelFound = -1;

    // find shortest path (only nodes) to reach a node from root using dijkstra algorithm
    let dijkstraOptions: Cy.SearchDijkstraOptions = {
      root: cy.nodes().roots().first(),
      weight: null,
      directed: true
    };
    let dijkstra: Cy.SearchDijkstraResult = cy
      .elements()
      .dijkstra(dijkstraOptions);
    let pathToNode: Cy.NodeCollection = dijkstra
      .pathTo(cy.getElementById(node.id()))
      .filter("node");

    pathToNode.forEach((n: Cy.NodeCollection) => {
      if (WbsLayoutLevel.levelFound == -1) {
        level += 1;

        if (n.id() == node.id()) {
          WbsLayoutLevel.levelFound = level;
        }

        // console.log('');
        // console.log('pathNode id: ' + n.id() + ', level: ' + level);

        if (n.data().layoutStyle == 1 && WbsLayoutLevel.levelFound == -1) {
          // console.log(n.id() + ' is layoutStyle 1, so we start recursive function')
          level = WbsLayoutLevel.sumLayoutLevel(n, level, node);
          // console.log('recursive function give a result of ' + level + ' and levelFound is = ' + WbsLayoutLevel.levelFound);
        }
      }
    });

    return WbsLayoutLevel.levelFound;
  
  
  }

  private static sumLayoutLevel(
    node: Cy.NodeCollection,
    level: number,
    targetLayoutNode: Cy.NodeCollection
  ): number {
    if (WbsLayoutLevel.levelFound == -1) {
      // console.log('');
      // console.log('Recursive function on id: ' + node.id() + ' level: ' + level);

      if (node.children().length > 0) {
        if (node.data().layoutStyle == 1) {
          // console.log(node.id() + ' has children and is layoutStyle 1');

          node.children().forEach((c: Cy.NodeCollection) => {
            level += 1;
            // console.log('before test, level is ' + level);
            if (c.id() == targetLayoutNode.id()) {
              // console.log('found target test, level is ' + level);
              WbsLayoutLevel.levelFound = level;
              // console.log(c.id() + ' is targetLayoutNode, SHOULD STOP HERE, levelFound = ' + WbsLayoutLevel.levelFound);
              return false;
            }

            if (WbsLayoutLevel.levelFound == -1) {
              // console.log('child id: ' + c.id() + ', level = ' + level);
              if (c.data().layoutStyle == 1) {
                level = WbsLayoutLevel.sumLayoutLevel(
                  c,
                  level,
                  targetLayoutNode
                );
              }
            }
          });
        } else {
          level += 1;
          // console.log(node.id() + ' has children and is layoutStyle 0');
          // console.log('level = ' + level);
          // console.log('because id: ' + node.id() + ' is layoutStyle 0, we call recursive function on first child only');
          level = WbsLayoutLevel.sumLayoutLevel(
            node.children().first(),
            level,
            targetLayoutNode
          );
        }
      } else {
        if (node.id() == targetLayoutNode.id()) {
          WbsLayoutLevel.levelFound = level;
          // console.log(node.id() + ' is leaf, level is ' + level);
        }
        // console.log(node.id() + ' is leaf, level is ' + level);
      }
    }
    return level;
  }
}



// WEBPACK FOOTER //
// ./src/layout/WbsLayoutLevel.ts